// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/dist/vuetify.min.js'
import router from './router'
import store from './store'
//import './registerServiceWorker'
import VueQuillEditor from 'vue-quill-editor'
import './styles/main.css'
import VueSimplemde from 'vue-simplemde'
import 'simplemde/dist/simplemde.min.css'

Vue.use(VueFire)
Vue.config.productionTip = false
Vue.use(VueQuillEditor)
Vue.use(VueSimplemde)
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import Notification from 'vue-notification'
Vue.use(Notification)
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  theme: {
    primary: colors.green,
    error: colors.red.accent3
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js